export default "__VITE_PUBLIC_ASSET__f0d97b2f__"